import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const fieldSlotRecipe = defineSlotRecipe({
  slots: ['label'],
  base: {
    label: defineStyle({
      marginRight: 'unset !important',
      display: 'inherit',
      fontWeight: '400',
      fontSize: '12px !important',
      color: 'fg.subtle',
    }),
  },
});

export default fieldSlotRecipe;
